export interface CmsRegisterAnotherAppliancePanel {
  registerAnotherAppliancePanelBody: string;
  registerAnotherAppliancePanelExternalUrl: string;
  registerAnotherAppliancePanelTitle: string;
}
